import styled from 'styled-components'

export default styled.div`
    flex: 7
    height: 85vh
    padding-left: 20px
    overflow: auto
    & .svg {
        height: 20px
    }
    & .SVGInline {
        display: flex
    }
    
`